<h2 mat-dialog-title>Attention</h2>
<mat-dialog-content>
	<p> There are changes you have made to the form. If you leave, you will lose your changes. </p>
</mat-dialog-content>
<mat-dialog-actions>
	<button mat-raised-button [mat-dialog-close]="false">Cancel</button>
	<button mat-raised-button color="primary" [mat-dialog-close]="true">Continue</button>
</mat-dialog-actions>